const prefix = 'hc-numeric-input';

/**
 * Collection of class names inside Input component.
 *
 * These styles basically only mark input component in named way in case you want to override styles in parent
 */
export const NumericInputClassNames = {
  Root: `${prefix}-root`,
  Label: `${prefix}-label`,
  MainWrapper: `${prefix}-main-wrapper`,
  Main: `${prefix}-main`,
  Error: `${prefix}-error`,
  Mask: `${prefix}-mask`,
  MaskWrapper: `${prefix}-mask-wrapper`,
  Unit: `${prefix}-unit`,
} as const;
